import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../common/form';

import * as utils from '../../utils/utilities';

class HelideckPhotographicRecord extends Form {
	state = {
		data: {
			generalView: [],
			accessStairway: [],
			perimeterGeneralView: [],
			personnelGridlines: [],
			gridlineMarkings: [],
			frictionTestMachine: [],
			personnelFrictionTest: [],
			personnelWetCondition: [],
			helideckSurfaceWater: [],
			crashEquipmentBox: [],
			powerPressureVessel: [],
		},
		errors: {},
		loading: false,
		progress: 0,
		places: [],
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		generalView: Joi.array().min(1).required().label('General View'),
		accessStairway: Joi.array().min(1).required().label('Access Stairway'),
		perimeterGeneralView: Joi.array()
			.min(1)
			.required()
			.label('Perimeter General View'),
		personnelGridlines: Joi.array()
			.min(1)
			.required()
			.label('Personnel Gridlines'),
		gridlineMarkings: Joi.array().min(1).required().label('Gridline Markings'),
		frictionTestMachine: Joi.array()
			.min(1)
			.required()
			.label('Friction Test Machine'),
		personnelFrictionTest: Joi.array().min(1).required().label('Friction Test'),
		personnelWetCondition: Joi.array()
			.min(1)
			.required()
			.label('Spraying Water'),
		helideckSurfaceWater: Joi.array()
			.min(1)
			.required()
			.label('Helideck Surface with Water'),
		crashEquipmentBox: Joi.array()
			.min(1)
			.required()
			.label('Crash Equipment Box'),
		powerPressureVessel: Joi.array()
			.min(1)
			.required()
			.label('Powder Pressure Vessel'),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data);
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
				<div className="row">
					<div className="col">
						{this.renderFileInput({
							max: 4,
							multiple: true,
							name: 'generalView',
							accept: 'image/*,application/pdf',
							label: 'General View',
							sublabel: 'General view of the helideck',
							types: utils.getFileUploadTypes(),
						})}
					</div>
					<div className="col">
						{this.renderFileInput({
							max: 4,
							multiple: true,
							name: 'accessStairway',
							accept: 'image/*,application/pdf',
							label: 'Access Stairway',
							sublabel:
								'View of access stairway on west and east side of the helideck.',
							types: utils.getFileUploadTypes(),
						})}
					</div>
				</div>

				<div className="row">
					<div className="my-4 divider"></div>
					<div className="col">
						{this.renderFileInput({
							max: 4,
							multiple: true,
							name: 'perimeterGeneralView',
							accept: 'image/*,application/pdf',
							label: 'Perimeter General View',
							sublabel:
								'General view of helideck perimeter and flood light fittings.',
							types: utils.getFileUploadTypes(),
						})}
					</div>
					<div className="col">
						{this.renderFileInput({
							max: 4,
							multiple: true,
							name: 'personnelGridlines',
							accept: 'image/*,application/pdf',
							label: 'Personnel Gridlines',
							sublabel: 'Personnel drawing gridlines on deck before the test.',
							types: utils.getFileUploadTypes(),
						})}
					</div>
				</div>

				<div className="row">
					<div className="my-4 divider"></div>
					<div className="col">
						{this.renderFileInput({
							max: 4,
							multiple: true,
							name: 'gridlineMarkings',
							accept: 'image/*,application/pdf',
							label: 'Gridline Markings',
							sublabel:
								'View showing section of the Helideck with gridline markings.',
							types: utils.getFileUploadTypes(),
						})}
					</div>

					<div className="col">
						{this.renderFileInput({
							max: 4,
							multiple: true,
							name: 'frictionTestMachine',
							accept: 'image/*,application/pdf',
							label: 'Friction Test Machine',
							sublabel:
								'View of the T2GO friction test machine with the calibration weight hanging freely on front wheel during calibration.',
							types: utils.getFileUploadTypes(),
						})}
					</div>
				</div>

				<div className="row">
					<div className="my-4 divider"></div>
					<div className="col">
						{this.renderFileInput({
							max: 4,
							multiple: true,
							name: 'personnelFrictionTest',
							accept: 'image/*,application/pdf',
							label: 'Friction Test',
							sublabel: 'Personnel conducting the friction test.',
							types: utils.getFileUploadTypes(),
						})}
					</div>

					<div className="col">
						{this.renderFileInput({
							max: 4,
							multiple: true,
							name: 'personnelWetCondition',
							accept: 'image/*,application/pdf',
							label: 'Spraying Water',
							sublabel:
								'Personnel spraying water on deck surface for wet condition test.',
							types: utils.getFileUploadTypes(),
						})}
					</div>
				</div>

				<div className="row">
					<div className="my-4 divider"></div>
					<div className="col">
						{this.renderFileInput({
							max: 4,
							multiple: true,
							name: 'helideckSurfaceWater',
							accept: 'image/*,application/pdf',
							label: 'Helideck Surface with Water',
							sublabel:
								'General view of helideck surface with water for wet condition test.',
							types: utils.getFileUploadTypes(),
						})}
					</div>

					<div className="col">
						{this.renderFileInput({
							max: 4,
							multiple: true,
							name: 'crashEquipmentBox',
							accept: 'image/*,application/pdf',
							label: 'Crash Equipment Box',
							sublabel:
								'Crash equipment box, fire men cabinet and fire extinguishers on full landing of stairway west side of helideck',
							types: utils.getFileUploadTypes(),
						})}
					</div>
				</div>

				<div className="my-4 divider"></div>

				{this.renderFileInput({
					max: 4,
					multiple: true,
					name: 'powerPressureVessel',
					accept: 'image/*,application/pdf',
					label: 'Powder Pressure Vessel',
					sublabel:
						'Foam and powder pressure vessel tank connected to hose reel system with nozzles at east and west access to the helideck',
					types: utils.getFileUploadTypes(),
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

export default HelideckPhotographicRecord;
